import "./Media.css";
import { CSSProperties } from "react";
import { usePreference } from "../../../context/usePreference";
import { GetArrayDataCollectionList } from "../../../utils/arrayHelperList";
import { renderRowTableRowFirstWhenContentIsZero } from "./MediaUtils";

export function MediaTableRowFirst({ rowContent, rowID }) {
  const row = rowContent;
  const u = usePreference();
  const { userPreference, userTarget } = usePreference();

  const Target = userPreference.Praca?.Targets?.find(
    (target) => target.Id === userTarget.Target?.Id
  ) ?? userPreference.Praca?.Targets?.[0];
  
  const rowHeight: CSSProperties = {
    height: u.userPreference?.TipoBase == 0 ? "50px" : "72px",
  };

  let classColor = rowID % 2 == 0 ? "Media_tableRow" : "Media_tableRow even";

  if (rowID == 0) {
    classColor += " type1";
  } else if (rowContent[2] == "0") {
    classColor = "Media_tableRowAlert";
  }

  classColor += " dobleIndice ";

  if (u.userPreference?.TipoBase === 0) {
    return (
      <tr className={classColor} style={rowHeight}>
        {renderRowTableRowFirstWhenContentIsZero(
          rowContent,
          row,
          rowID,
          Target,
        )}
      </tr>
    );
  } else {
    let rowFiltred = row?.filter(function (val, rowID) {
      return rowID == 0 || rowID == 1;
    });

    return (
      <tr className={classColor} style={rowHeight}>
        {rowContent[2] === "0" ? (
          GetArrayDataCollectionList(row).map(
            (val, rowID_row) =>
              rowID_row === 0 && (
                <td
                  style={{ color: "#7C6617", textAlign: "center" }}
                  key={val.dataID}
                >
                  <i
                    className="header-icon-13"
                    style={{
                      fontSize: "12px",
                      left: "-5px",
                      position: "relative",
                      color: "#c9a404",
                    }}
                  ></i>{" "}
                  {rowID === 0 && rowID_row === 0 ? (
                    <span className="media_spanBar">[</span>
                  ) : (
                    <></>
                  )}
                  {val.Data.split("-")[0]}
                  <br />
                  {val.Data.split("-")[1]}
                  <br />
                  {rowFiltred[1]}
                </td>
              )
          )
        ) : (
          <td colSpan={1}>
            <div className="divfirstRow">
              <tr style={{ color: "white", textAlign: "center" }} key={rowID}>
                {rowID === 0 ? <span className="media_spanBar">[</span> : <></>}
                {rowFiltred[0].split("-")[0]}
                <br />
                {rowFiltred[0].split("-")[1]}
              </tr>
              <tr style={{ textAlign: "center", color: "black" }}>
                <p style={{ margin: "0px" }}>
                  <i
                    className={"header-icon-" + Target.Id}
                    style={{ fontSize: "12px" }}
                  ></i>
                  <span style={{ color: "white" }}>{rowFiltred[1]}</span>
                </p>
              </tr>
            </div>
          </td>
        )}
      </tr>
    );
  }
}